import image from "../Images/hospital.png";
import image2 from "../Images/lipstick.png";
import image3 from "../Images/pure skin.png";
import image4 from "../Images/cosmetics.png";
import person1 from "../Images/Hairstyles/person1.jpeg";
import person2 from "../Images/Hairstyles/person2.jpeg";
import person3 from "../Images/Hairstyles/person3.jpeg";
import person4 from "../Images/Hairstyles/person4.jpeg";
import person5 from "../Images/Hairstyles/person5.jpeg";
import person6 from "../Images/Hairstyles/person6.jpeg";

export const blog = [
  {
    id: 1,
    title: "New Partnership",
    image: image,
    text: "Started a new partnership with Winfield Hospital because our customer's health matters more",
  },
  {
    id: 2,
    title: "New Products",
    image: image2,
    text: "Got new lipsticks from Blink Blink, to give our customers the best results possible ",
  },
  {
    id: 3,
    title: "Sponsorship",
    image: image3,
    text: "Got a new sponsorship from Pure Skin company, for better skincare for our customers.",
  },
  {
    id: 4,
    title: "Cosmetics Event",
    image: image4,
    text: "A cosmetics event for our staffs to show off their favorite products.",
  },
];

export const reviews = [
  {
    id: 1,
    image: person1,
    name: " Anna Frost",
    review:
      "I really loved the hairstyle, it ws not painful at all and the result was fantastic",
  },
  {
    id: 2,
    image: person2,
    name: "James Kane",
    review:
      "I really loved the haircut,and the customer service was the really good.",
  },
  {
    id: 3,
    image: person3,
    name: "Alec Frane",
    review:
      "The website functionality is amazing, I placed my order and got in contact with the staff in charge so i can pick a comfortable time for me",
  },
  {
    id: 4,
    image: person4,
    name: "Kris Frost",
    review:
      "I really loved the hairstyle, it ws not painful at all and the result was fantastic",
  },
  {
    id: 5,
    image: person5,
    name: "Ann Krane",
    review:
      "I really loved the hairstyle, I got what I ordered,The staffs are very professional",
  },
  {
    id: 6,
    image: person6,
    name: "Alin Pane",
    review: "My haircut boosted my self-confidence a lot",
  },
];
